import { env } from 'next-runtime-env';

export function getHuutokaupatApiBaseUrl(): string {
  return (typeof window === 'undefined' ? env('INTERNAL_HUUTOKAUPAT_BASE_URL') : env('NEXT_PUBLIC_BASE_URL')) ?? '';
}
